import Swiper, { EffectFade } from 'swiper';
import { useFilter } from './components/filter';
// import { useYoutube } from './modules/_utils'
import { openModal } from './components/modal';

const useSpotSwiper = () => {
  const swiperName = '.spot-swiper'
  
  const options = {
    modules: [EffectFade],
    speed: 500,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    }
  }

  return new Swiper(swiperName, options)
}

const useSpotList = () => {
  const spotSwiper = useSpotSwiper()
  const spotScroller = $('.spot-scroller')
  const spotList = $('.spot-list')
  const spotListItem = spotList.find('.spot-list_item')
  if (!spotScroller.length || !spotList.length) return;

  // 點擊切換播放中
  spotListItem.each((i, el) => {
    const self = $(el)
    if (i === 0) {
      self.addClass('is-active')
    }

    self.on('click', () => {
      spotSwiper.slideTo(i)
    })
  })

  spotSwiper.on('slideChange', (swiper) => {
    const { activeIndex } = swiper
    $(spotListItem[activeIndex]).addClass('is-active').siblings().removeClass('is-active')
  })

  // spot-list 捲軸遮罩
  const clientRect = {
    scroller: {
      x: spotScroller[0].getBoundingClientRect().width,
      y: spotScroller[0].getBoundingClientRect().height
    },
    list: {
      x: spotList[0].getBoundingClientRect().width,
      y: spotList[0].getBoundingClientRect().height
    }
  }

  const scrollDetect = (direction) => {
    spotScroller.addClass('is-scrollable')
    const end = Math.floor(clientRect.list[direction] - clientRect.scroller[direction])
    const scrollDirection = direction === 'x' ? 'scrollLeft' : 'scrollTop'
    const scrollPos = spotScroller[scrollDirection]()
    if (scrollPos <= 0) spotScroller.addClass('is-start')
    else spotScroller.removeClass('is-start')
    if (scrollPos >= end) spotScroller.addClass('is-end')
    else spotScroller.removeClass('is-end')
  }

  const scrollHandler = () => {
    // scroll X
    if (clientRect.list.x > clientRect.scroller.x) {
      scrollDetect('x')
    }
    // scroll Y
    else if (clientRect.list.y > clientRect.scroller.y) {
      scrollDetect('y')
    }
    else {
      spotScroller.removeClass('is-scrollable')
    }
  }

  scrollHandler()
  spotScroller.on('scroll', scrollHandler)
  $(window).on('resize', () => {
    setTimeout(() => {
      clientRect.scroller.x = spotScroller[0].getBoundingClientRect().width
      clientRect.scroller.y = spotScroller[0].getBoundingClientRect().height
      clientRect.list.x = spotList[0].getBoundingClientRect().width
      clientRect.list.y = spotList[0].getBoundingClientRect().height
      scrollHandler()
    }, 100)
  })
}

// const useYoutube = () => {
//   const triggers = $('[data-youtube-id]')
//   const youtubeModal = $('#youtube-modal')

//   if (!triggers.length || !youtubeModal.length) return;
//   triggers.each((i, el) => {
//     const trigger = $(el)
//     const youtubeId = trigger.attr('data-youtube-id')
//     if (!youtubeId) return;

//     trigger.on('click', () => {
//       youtubeModal.find('iframe')[0].src = `https://www.youtube.com/embed/${youtubeId}`
//     })
//   })
// }

const openYoutubeModal = (data) => {
  const youtubeModal = $('#youtube-modal')
  if (!youtubeModal.length) return;

  const  { youtubeID = '', tag = '', date = '', title = '', content = '', link = {} } = data
  const { text: linkText = '', href: linkHref = '' } = link
  const articleBox = youtubeModal.find('.article-box')
  const linkBtn = articleBox.find('.btn-group')
  youtubeModal.find('iframe')[0].src = `https://www.youtube.com/embed/${youtubeID}`
  articleBox.find('.article-tags .tag').text(tag)
  articleBox.find('.article-date span').text(date)
  articleBox.find('.article-title').text(title)
  articleBox.find('.article-editor').html(content)
  if (!linkHref) {
    linkBtn.hide()
  }
  else {
    linkBtn.show()
    linkBtn.find('.rect-btn').attr('href', linkHref)
    linkBtn.find('.rect-btn span').text(linkText || linkHref)
  }

  setTimeout(() => {
    openModal('#youtube-modal')
  }, 100)
}

window.openYoutubeModal = openYoutubeModal


$(() => {
  useFilter()
  useSpotList()
  // useYoutube()
})